"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rioMobileSpacings = exports.rioDesktopSpacings = void 0;
exports.rioDesktopSpacings = {
    doubleLarge: '48px',
    extraLargePlus: '40px',
    extraLarge: '32px',
    large: '24px',
    mediumPlus: '20px',
    medium: '16px',
    base: '12px',
    small: '8px',
    mini: '4px',
    micro: '4px'
};
exports.rioMobileSpacings = {
    doubleLarge: '4.8rem',
    extraLargePlus: '4.0rem',
    extraLarge: '3.2rem',
    large: '2.4rem',
    mediumPlus: '2.0rem',
    medium: '1.6rem',
    base: '1.2rem',
    small: '.8rem',
    mini: '.4rem',
    micro: '.4rem'
};
